<template>
  <b-card title="ผลการค้นหา">
    <slot></slot>
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <!-- <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group> -->
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      @on-page-change="onPageChange"
      @on-per-page-change="onPageLengthChange"
      :totalRows="totalRecords"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'caseCode'" class="text-nowrap">
          {{ props.row.createDateStr }}
          <br />
          {{ props.row.complaintCode }}
          <br />
          {{ props.row.ocpbComplaintCode }}
        </span>

        <span v-if="props.column.field === 'department'" class="text-nowrap">
          <!-- <span
            v-if="
              props.row.departmentName !== null &&
                props.row.departmentName !== undefined
            "
          >
            {{ props.row.departmentName.substring(0, 100)
            }}{{ props.row.departmentName.length >= 100 ? "..." : "" }}
          </span> -->
          <span>
            {{ props.row.departmentName }}
          </span>
        </span>

        <span v-if="props.column.field === 'status'" class="text-nowrap">
          {{ props.row.isSuccess === true ? "สำเร็จ" : "ไม่สำเร็จ" }}

          <br />
          {{ props.row.mode }}
          <br />
          {{ props.row.createByName }}
        </span>

        <span
          v-if="props.column.field === 'dataDescription'"
          class="text-nowrap"
        >
          <b-button
            variant="outline-primary"
            @click="onDataResponseViewClicked(props.row)"
          >
            <feather-icon icon="EyeIcon" class="mr-50" /> ดูรายละเอียด
          </b-button>
        </span>

        <span v-if="props.column.field === 'action'" class="text-nowrap">
          <b-button
            v-if="props.row.isSuccess === false"
            variant="primary"
            @click="onResendClicked(props.row.id)"
          >
            <feather-icon icon="RepeatIcon" class="mr-50" />
            ส่งอีกครั้ง
          </b-button>
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '50', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

    <ModalDataResponse ref="modal-data-response" :obj="rowObj" />
  </b-card>
</template>

<script>
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  VBTooltip,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import { codeBasic } from "@/views/table/vue-good-table/code";
import appsettings from "@/store/app-settings";

import ModalDataResponse from "./ModalDataResponse.vue";

import TableHeaders from "./commonTableHeader.js";
import * as logExternalServiceStore from "@/store/api/logExternalService/index.js";
import * as userData from "@/auth/localStorageUtils.js";

export default {
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  components: {
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,
    TableHeaders,
    ModalDataResponse,
  },
  props: {
    searchMode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    return {
      tabMode: props.mode,
    };
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      codeBasic,
      columns: TableHeaders,
      rows: [],
      searchTerm: "",
      params: {},
      totalRecords: 0,
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
      rowObj: {
        dataDescription: "",
      },
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  methods: {
    onResendClicked(id) {
      const _this = this;
      this.$swal({
        title: "คุณต้องการส่งเรื่องอีกครั้งใช่หรือไม่?",
        text: "คุณต้องการส่งเรื่องอีกครั้งใช่หรือไม่!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ส่งเรื่อง",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          logExternalServiceStore
            .Resend(id)
            .then(function(response) {
              //console.log("resend", response, response.data, response.data.success)
              if (response.data.success === true) {
                _this.$swal({
                  icon: "success",
                  title: "ส่งเรื่อง สำเร็จ",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
                _this.onSearchSubmit(_this.params, _this.page);
              } else {
                _this.$swal({
                  icon: "error",
                  title: "เกิดข้อผิดพลาด",
                  customClass: {
                    confirmButton: "btn btn-error",
                  },
                });
              }
            })
            .catch(function(error) {
              console.log("error", error)
              _this.$swal({
                icon: "error",
                title: "เกิดข้อผิดพลาด",
                customClass: {
                  confirmButton: "btn btn-error",
                },
              });
            })
            .then(function() {
              _this.$emit("handleOverlay", false);
            });
        }
      });
    },
    onDataResponseViewClicked(item) {
      this.rowObj = item;
      console.log("ref", this.$refs["modal-data-response"]);
      this.$refs["modal-data-response"].$refs["modal-data-response"].show();
    },
    onSearchSubmit(params, page = { currentPage: 1 }) {
      var _this = this;

      params.page = page.currentPage;
      params.perPage = this.pageLength;

      _this.$emit("handleOverlay", true);

      logExternalServiceStore
        .getForSearch(params)
        .then(function(response) {
          _this.rows = response.data.data;
          try {
            _this.totalRecords = response.data.data[0].totalCount;
          } catch (ex) {
            console.log("get total records error", ex);
            _this.totalRecords = 0;
          }
        })
        .catch(function(error) {
          console.log("error", error);
          _this.rows = [];
          _this.totalRecords = 0;
        })
        .then(function() {
          _this.$emit("handleOverlay", false);
        });
    },
    onPageChange(page) {
      console.log("onPageChanged", page);
      this.onSearchSubmit(this.params, page);
    },
    onPageLengthChange(pageLength) {
      console.log("onPageLengthChanged", pageLength);
      this.onSearchSubmit(this.params, 1);
    },
    confirmText() {
      this.$swal({
        title: "คุณต้องการลบข้อมูลใช่หรือไม่?",
        text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบข้อมูล",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$swal({
            icon: "success",
            title: "ลบข้อมูล สำเร็จ",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
  },
};
</script>
